import { Stack, Title } from '@common/ui'
import React from 'react'
import { com } from '@eidu/web'
import KindInput from '../input/KindInput'
import LabelDisplay from './LabelDisplay'
import EntityType = com.eidu.entity.type.EntityType
import FieldDisplay from './FieldDisplay'

type FieldsStackProps = {
  entityType: EntityType
  entityTypes: readonly EntityType[]
}

const FieldsStack = ({ entityType, entityTypes }: FieldsStackProps) => {
  const fields = entityType.fields.asJsReadonlyArrayView()

  const primaryLabel = entityType.label.primary
  const secondaryLabel = entityType.label.secondary || undefined

  return (
    <Stack gap="lg">
      {fields.length > 0 && (
        <>
          <Title order={3}>Kind</Title>
          <KindInput kind={entityType.kind} />
        </>
      )}

      {fields.length > 0 && <Title order={3}>Fields</Title>}
      {fields.map((field) => (
        <Stack key={field.id.toString()}>
          <FieldDisplay availableEntityTypes={entityTypes} field={field} />
        </Stack>
      ))}
      {fields.length > 0 && (
        <LabelDisplay fields={fields} primaryLabel={primaryLabel} secondaryLabel={secondaryLabel} />
      )}
    </Stack>
  )
}

export default FieldsStack
